import { render } from "./DataGrid.vue?vue&type=template&id=77e65915&scoped=true"
import script from "./DataGrid.vue?vue&type=script&lang=js"
export * from "./DataGrid.vue?vue&type=script&lang=js"

import "./DataGrid.vue?vue&type=style&index=0&id=77e65915&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e65915"]])

export default __exports__